export default __webpack_public_path__ + "components/page-footer/static/play-store-86d7c8227ce71d8e5e8826125dfe5964.png";